import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";
import { debounce } from "../helpers/timing_helpers";

export default class extends Controller {
  static values = {
    asyncSrc: String,
  };

  async connect() {
    this.search = debounce(this.search.bind(this), 100);
    this.element.disabled = true;
    try {
      await this._fetch();
    } finally {
      this.element.disabled = false;
    }
  }

  async search() {
    await this._fetch(this.element.inputValue);
  }

  async _fetch(q = "") {
    const url = new URL(this.asyncSrcValue, window.location.origin);
    if (q) url.searchParams.set("q", q);
    await get(url.toString(), { responseKind: "turbo-stream" });
  }
}
